var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cb-modal",class:{ show : _vm.showing }},[_c('div',{staticClass:"cb-modal-template-lg"},[_c('div',{staticClass:"cbm-header"},[_vm._t("header")],2),_vm._v(" "),_c('div',{staticClass:"cbm-body"},[_vm._t("body",function(){return [_vm._v("\n                default body\n            ")]})],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }